import React from "react";
import RoundIcon from "../RoundIcon";
import UsaFlag from "../PageDocumentCountrySelector/UsaFlag";
import IrlFlag from "../PageDocumentCountrySelector/IrlFlag";
import UKFlag from "../PageDocumentCountrySelector/UKFlag";
import AustraliaFlag from "../PageDocumentCountrySelector/AustraliaFlag";
import NewZealand from "../PageDocumentCountrySelector/NewZealandFLag";

function FlagRenderer(props) {
  let noDoc;

  switch (props.flag) {
    case "us":
      noDoc = "";
      break;
    case "au":
      noDoc = "";
      break;
    case "nz":
      noDoc = "";
      break;
    case "gb":
      noDoc = "";
      break;
    case "ie":
      noDoc = "";
      break;
    default:
      noDoc = "noDoc";
  }

  return (
    <RoundIcon color="blue" noDoc={noDoc ? noDoc : null}>
      {props.flag === "us" ? (
        <UsaFlag />
      ) : props.flag === "gb" ? (
        <UKFlag />
      ) : props.flag === "ie" ? (
        <IrlFlag />
      ) : props.flag === "au" ? (
        <AustraliaFlag />
      ) : props.flag === "nz" ? (
        <NewZealand />
      ) : null}{" "}
    </RoundIcon>
  );
}

export default FlagRenderer;
